module.exports = __webpack_public_path__ + "static/peg-end-breakoff-8e65fdd7184eec623a624253f15c2f38.gif";